import { EventEmitter, ElementRef, QueryList, ChangeDetectorRef, PLATFORM_ID, Renderer2, DOCUMENT } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiHeaderFooterBundle, UiFooterComponent, UiTemplateDirective } from '../shared';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ObjectUtils } from 'prime-ng-old/utils';
import { OrderList as OrderListBase } from 'prime-ng-old/orderlist';
import { findIndexInList } from '../utils';
import { DomHandler } from 'prime-ng-old/dom';
import { FilterService, PrimeNGConfig } from 'prime-ng-old/api';
import { UiSpinnerComponent } from '../spinner';
import { UiContentCenteredComponent } from '../content-centered';
import { SearchIcon } from 'prime-ng-old/icons/search';
import { UiIconsModule } from '../icons';
import * as i0 from "@angular/core";
import * as i1 from "prime-ng-old/api";
import * as i2 from "@angular/common";
import * as i3 from "../icons/icon.component";
import * as i4 from "@angular/cdk/drag-drop";
const _c0 = ["listelement"];
const _c1 = [[["ui-footer"]]];
const _c2 = ["ui-footer"];
const _c3 = (a0, a1, a2, a3) => ({
  "p-orderlist p-component": true,
  "p-orderlist-striped": a0,
  "p-orderlist-controls-left": a1,
  "p-orderlist-controls-right": a2,
  "p-dragdrop-enable": a3
});
const _c4 = a0 => ({
  options: a0
});
const _c5 = (a0, a1, a2, a3, a4) => ({
  "p-highlight": a0,
  "p-disabled": a1,
  "p-focus": a2,
  "drag-handle-left": a3,
  "selectable": a4
});
const _c6 = (a0, a1) => ({
  $implicit: a0,
  index: a1
});
function UiOrderListComponent_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.header);
  }
}
function UiOrderListComponent_Conditional_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiOrderListComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵconditionalCreate(1, UiOrderListComponent_Conditional_2_Conditional_1_Template, 2, 1, "div", 9);
    i0.ɵɵtemplate(2, UiOrderListComponent_Conditional_2_ng_container_2_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "header");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.headerTemplate ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate);
  }
}
function UiOrderListComponent_Conditional_3_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiOrderListComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiOrderListComponent_Conditional_3_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.filterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c4, ctx_r0.filterOptions));
  }
}
function UiOrderListComponent_Conditional_3_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SearchIcon", 14);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-orderlist-filter-icon");
    i0.ɵɵattribute("data-pc-section", "filterIcon");
  }
}
function UiOrderListComponent_Conditional_3_Conditional_2_Conditional_4_1_ng_template_0_Template(rf, ctx) {}
function UiOrderListComponent_Conditional_3_Conditional_2_Conditional_4_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiOrderListComponent_Conditional_3_Conditional_2_Conditional_4_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiOrderListComponent_Conditional_3_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtemplate(1, UiOrderListComponent_Conditional_3_Conditional_2_Conditional_4_1_Template, 1, 0, null, 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("data-pc-section", "filterIcon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.filterIconTemplate);
  }
}
function UiOrderListComponent_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "input", 13, 1);
    i0.ɵɵlistener("keyup", function UiOrderListComponent_Conditional_3_Conditional_2_Template_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onFilterKeyup($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, UiOrderListComponent_Conditional_3_Conditional_2_Conditional_3_Template, 1, 2, "SearchIcon", 14);
    i0.ɵɵconditionalCreate(4, UiOrderListComponent_Conditional_3_Conditional_2_Conditional_4_Template, 2, 2, "span", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "filter");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r0.disabled);
    i0.ɵɵattribute("placeholder", ctx_r0.filterPlaceholder)("aria-label", ctx_r0.ariaFilterLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.filterIconTemplate ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.filterIconTemplate ? 4 : -1);
  }
}
function UiOrderListComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵconditionalCreate(1, UiOrderListComponent_Conditional_3_Conditional_1_Template, 1, 4, "ng-container")(2, UiOrderListComponent_Conditional_3_Conditional_2_Template, 5, 6, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("data-pc-section", "filterContainer");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.filterTemplate ? 1 : 2);
  }
}
function UiOrderListComponent_For_7_Conditional_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
  }
}
function UiOrderListComponent_For_7_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiOrderListComponent_For_7_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 19);
    i0.ɵɵelement(1, "ui-icon", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", "drag-handle-" + ctx_r0.dragId);
  }
}
function UiOrderListComponent_For_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 17);
    i0.ɵɵlistener("click", function UiOrderListComponent_For_7_Conditional_0_Template_li_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      const item_r5 = ctx_r3.$implicit;
      const ɵ$index_41_r6 = ctx_r3.$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onItemClick($event, item_r5, ɵ$index_41_r6, ctx_r0.id + "_" + ɵ$index_41_r6));
    })("touchend", function UiOrderListComponent_For_7_Conditional_0_Template_li_touchend_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onItemTouchEnd());
    })("mousedown", function UiOrderListComponent_For_7_Conditional_0_Template_li_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ɵ$index_41_r6 = i0.ɵɵnextContext().$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onOptionMouseDown(ɵ$index_41_r6));
    });
    i0.ɵɵtemplate(1, UiOrderListComponent_For_7_Conditional_0_div_1_Template, 1, 0, "div", 18)(2, UiOrderListComponent_For_7_Conditional_0_ng_container_2_Template, 1, 0, "ng-container", 12);
    i0.ɵɵconditionalCreate(3, UiOrderListComponent_For_7_Conditional_0_Conditional_3_Template, 2, 1, "span", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const item_r5 = ctx_r3.$implicit;
    const ɵ$index_41_r6 = ctx_r3.$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.id + "_" + ɵ$index_41_r6)("ngClass", i0.ɵɵpureFunction5(11, _c5, ctx_r0.isSelected(item_r5), ctx_r0.disabled, ctx_r0.id + "_" + ɵ$index_41_r6 === ctx_r0.focusedOptionId(), ctx_r0.dragHandlePosition === "left", ctx_r0.selectable))("cdkDragData", item_r5)("cdkDragDisabled", !ctx_r0.dragdrop);
    i0.ɵɵattribute("aria-selected", ctx_r0.isSelected(item_r5))("data-pc-section", "item")("data-p-highlight", ctx_r0.isSelected(item_r5))("data-p-focused", ctx_r0.id + "_" + ɵ$index_41_r6 === ctx_r0.focusedOptionId());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(17, _c6, item_r5, ɵ$index_41_r6));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.dragdrop ? 3 : -1);
  }
}
function UiOrderListComponent_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiOrderListComponent_For_7_Conditional_0_Template, 4, 20, "li", 16);
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.isItemVisible(item_r5) ? 0 : -1);
  }
}
function UiOrderListComponent_Conditional_8_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiOrderListComponent_Conditional_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 22);
    i0.ɵɵtemplate(1, UiOrderListComponent_Conditional_8_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "emptyMessage");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.emptyMessageTemplate);
  }
}
function UiOrderListComponent_Conditional_8_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiOrderListComponent_Conditional_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 22);
    i0.ɵɵtemplate(1, UiOrderListComponent_Conditional_8_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "emptyMessage");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.emptyFilterMessageTemplate);
  }
}
function UiOrderListComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiOrderListComponent_Conditional_8_Conditional_0_Template, 2, 2, "li", 22);
    i0.ɵɵconditionalCreate(1, UiOrderListComponent_Conditional_8_Conditional_1_Template, 2, 2, "li", 22);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r0.filterValue || !ctx_r0.emptyFilterMessageTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.filterValue ? 1 : -1);
  }
}
function UiOrderListComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function UiOrderListComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "ui-content-centered");
    i0.ɵɵelement(2, "ui-spinner");
    i0.ɵɵelementEnd()();
  }
}
export let UiOrderListComponent = /*#__PURE__*/(() => {
  class UiOrderListComponent extends OrderListBase {
    set selectionLimit(val) {
      if (typeof val === 'string') {
        this._selectionLimit = parseInt(val, 10);
      } else if (val === false) {
        this._selectionLimit = 0;
      } else {
        this._selectionLimit = val;
      }
    }
    constructor(document, platformId, renderer, el, cd, filterService, config) {
      super(document, platformId, renderer, el, cd, filterService, config);
      this.el = el;
      this.cd = cd;
      this.filterService = filterService;
      this.config = config;
      this.fitHeight = false;
      this.showButtons = false;
      this.loading = false;
      this.allowDeselectAll = false;
      this.dragHandle = '.drag-handle';
      this.dragId = 'orderlist-' + Math.round(Math.random() * 100000).toString();
      this.dragHandlePosition = 'right';
      this.selectable = true;
      this.onReorderItems = new EventEmitter();
      // keyword multiple... set limit of selectable items
      this._selectionLimit = 0;
      this._selection = [];
      Object.defineProperty(this, "selection", {
        get() {
          return this._selection;
        },
        set(val) {
          if (!this.selectable) return;
          this._selection = Array.isArray(val) ? val : val != null ? [val] : [];
          this.selectionChange.emit(this._selection);
        }
      });
      // dragDrop.onDrop.pipe(
      // 	takeWhileAlive(),
      // 	filter(e=>e.scope===this.dragId)
      // ).subscribe((e)=>{
      // 	this.onDrop(e)
      // })
      this.onReorder.subscribe(() => {
        this.cd.markForCheck();
      });
    }
    setSelection(selection) {
      if (Array.isArray(selection)) {
        this.selection = selection;
      } else {
        this.selection = [selection];
      }
      this.cd.detectChanges();
    }
    onItemClick(event, item, index, selectedId) {
      if (!this.selectable) return;
      this.itemTouched = false;
      const selectedIndex = findIndexInList(item, this.selection);
      const alreadySelected = selectedIndex !== -1;
      const metaSelection = this.itemTouched ? false : this.metaKeySelection;
      let selectionChanged = false;
      const metaKey = event.metaKey || event.ctrlKey || event.shiftKey;
      if (selectedId) {
        this.focusedOptionIndex = selectedId;
      }
      if (alreadySelected) {
        if (this.allowDeselectAll || this._selection.length > 1) {
          if (!metaSelection || metaKey) {
            // deselect
            this._selection = this._selection.filter((val, i) => i !== selectedIndex);
          } else {
            // reset selection
            this._selection = [item];
          }
          selectionChanged = true;
        }
      } else {
        if (this._selectionLimit === 1) {
          // single item selection, dont do anything if there's one selected item and user tries to use metakey.
          if (this._selection.length === 0 || !(metaSelection && metaKey)) {
            // dont do anything if trying to use metakey 
            this._selection = [item];
            selectionChanged = true;
          }
        } else {
          // limit is greater than 1 or unlimited
          const extendingSelectionAllowed = this._selectionLimit === 0 || this._selectionLimit > this._selection.length;
          if (!metaSelection || metaKey) {
            // user tries to add to selection
            if (extendingSelectionAllowed) {
              this._selection = this._selection ? [...this._selection] : [];
              ObjectUtils.insertIntoOrderedArray(item, index, this._selection, this.value);
              selectionChanged = true;
            }
          } else {
            // metamode w/o metakey
            this._selection = [item];
            selectionChanged = true;
          }
        }
      }
      if (selectionChanged) {
        //binding
        this.selectionChange.emit(this._selection);
        //event
        this.onSelectionChange.emit({
          originalEvent: event,
          value: this._selection
        });
      }
    }
    isSelected(item) {
      if (!this.selectable) return false;
      return findIndexInList(item, this._selection) !== -1;
    }
    moveUp(event) {
      if (this._selection) {
        const actions = [];
        for (let i = 0; i < this._selection.length; i++) {
          const selectedItem = this._selection[i];
          const selectedItemIndex = findIndexInList(selectedItem, this.value);
          if (selectedItemIndex !== 0) {
            actions.push({
              from: selectedItemIndex,
              to: selectedItemIndex - 1
            });
            const movedItem = this.value[selectedItemIndex];
            const temp = this.value[selectedItemIndex - 1];
            this.value[selectedItemIndex - 1] = movedItem;
            this.value[selectedItemIndex] = temp;
          } else {
            break;
          }
        }
        this.movedUp = true;
        this.onReorder.emit(event);
        this.onReorderItems.emit({
          event,
          result: this.value,
          actions
        });
      }
    }
    moveTop(event) {
      if (this._selection) {
        const actions = [];
        for (let i = this._selection.length - 1; i >= 0; i--) {
          const selectedItem = this._selection[i];
          const selectedItemIndex = findIndexInList(selectedItem, this.value);
          if (selectedItemIndex !== 0) {
            actions.push({
              from: selectedItemIndex,
              to: 0
            });
            const movedItem = this.value.splice(selectedItemIndex, 1)[0];
            this.value.unshift(movedItem);
          } else {
            break;
          }
        }
        this.onReorder.emit(event);
        this.onReorderItems.emit({
          event,
          result: this.value,
          actions
        });
        this.listViewChild.nativeElement.scrollTop = 0;
      }
    }
    moveDown(event) {
      if (this._selection) {
        const actions = [];
        for (let i = this._selection.length - 1; i >= 0; i--) {
          const selectedItem = this._selection[i];
          const selectedItemIndex = findIndexInList(selectedItem, this.value);
          if (selectedItemIndex !== this.value.length - 1) {
            actions.push({
              from: selectedItemIndex,
              to: selectedItemIndex + 1
            });
            const movedItem = this.value[selectedItemIndex];
            const temp = this.value[selectedItemIndex + 1];
            this.value[selectedItemIndex + 1] = movedItem;
            this.value[selectedItemIndex] = temp;
          } else {
            break;
          }
        }
        this.movedDown = true;
        this.onReorderItems.emit({
          event,
          result: this.value,
          actions
        });
        this.onReorder.emit(event);
      }
    }
    moveBottom(event) {
      if (this._selection) {
        const actions = [];
        for (let i = 0; i < this._selection.length; i++) {
          const selectedItem = this._selection[i];
          const selectedItemIndex = findIndexInList(selectedItem, this.value);
          if (selectedItemIndex !== this.value.length - 1) {
            actions.push({
              from: selectedItemIndex,
              to: this.value.length - 1
            });
            const movedItem = this.value.splice(selectedItemIndex, 1)[0];
            this.value.push(movedItem);
          } else {
            break;
          }
        }
        this.onReorder.emit(event);
        this.onReorderItems.emit({
          event,
          result: this.value,
          actions
        });
        this.listViewChild.nativeElement.scrollTop = this.listViewChild.nativeElement.scrollHeight;
      }
    }
    mousedown(event) {
      this.handle = event.target;
    }
    mouseup(event) {
      this.handle = null;
    }
    allowDrag() {
      if (this.dragHandle && this.handle) return DomHandler.matches(this.handle, this.dragHandle);else return true;
    }
    onDragStart(event, index) {
      if (this.allowDrag()) {
        event.dataTransfer.setData('text', 'b'); // For firefox
        event.target.blur();
        // TODO: Not existing anymore
        // this.dragging = true;
        // this.draggedItemIndex = index; 
      } else {
        event.preventDefault();
      }
    }
    onDragEnd(event) {
      // TODO: Not existing anymore
      //  this.dragging = false;
    }
    onDrop(e) {
      const event = e;
      const draggedIndex = e.previousIndex;
      const dropIndex = e.currentIndex;
      // const item = e.item.data;
      const actions = [{
        from: draggedIndex,
        to: dropIndex
      }];
      const result = [...this.value];
      ObjectUtils.reorderArray(result, draggedIndex, dropIndex);
      // disabled to leave form arrays intact.
      // if required, this can be reenabled based on a input flag.
      // this.value = val;
      if (!this.onReorderItems.observed) console.warn('ui-orderlist found that no listener is attached to onReorderItems event! drop will have no effect!');
      // TODO: Not existing anymore
      // this.dragOverItemIndex = null;
      this.onReorder.emit(event);
      this.onReorderItems.emit({
        event,
        result,
        actions
      });
    }
    onItemKeydown(event) {
      if (this.selectable) {
        super.onItemKeydown(event);
      }
    }
    static {
      this.ɵfac = function UiOrderListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiOrderListComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.FilterService), i0.ɵɵdirectiveInject(i1.PrimeNGConfig));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiOrderListComponent,
        selectors: [["ui-orderList"]],
        contentQueries: function UiOrderListComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiFooterComponent, 5)(dirIndex, UiTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerFacet = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        viewQuery: function UiOrderListComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listViewChild = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function UiOrderListComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("fit-height", ctx.fitHeight);
          }
        },
        inputs: {
          fitHeight: "fitHeight",
          showButtons: "showButtons",
          loading: "loading",
          allowDeselectAll: "allowDeselectAll",
          dragHandlePosition: "dragHandlePosition",
          selectable: "selectable",
          selectionLimit: "selectionLimit"
        },
        outputs: {
          onReorderItems: "onReorderItems"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c2,
        decls: 11,
        vars: 23,
        consts: [["listelement", ""], ["filter", ""], [3, "ngClass", "ngStyle"], [1, "p-orderlist-list-container"], [1, "p-orderlist-header"], [1, "p-orderlist-filter-container"], ["cdkDropList", "", "role", "listbox", "aria-multiselectable", "true", 1, "p-orderlist-list", 3, "cdkDropListDropped", "focus", "blur", "keydown", "id", "ngStyle", "tabindex"], [1, "ui-panel-footer"], [1, "loading-overlay"], [1, "p-orderlist-title"], [4, "ngTemplateOutlet"], [1, "p-orderlist-filter"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "text", "role", "textbox", 1, "p-orderlist-filter-input", "p-inputtext", "p-input-text", "p-component", 3, "keyup", "disabled"], [3, "styleClass"], [1, "p-orderlist-filter-icon"], ["pRipple", "", "cdkDrag", "", "role", "option", "ghostMode", "native", 1, "p-orderlist-item", 3, "id", "ngClass", "cdkDragData", "cdkDragDisabled"], ["pRipple", "", "cdkDrag", "", "role", "option", "ghostMode", "native", 1, "p-orderlist-item", 3, "click", "touchend", "mousedown", "id", "ngClass", "cdkDragData", "cdkDragDisabled"], ["class", "cdk-drag-placeholder", 4, "cdkDragPlaceholder"], ["cdkDragHandle", "", 1, "drag-handle", 3, "ngClass"], [1, "cdk-drag-placeholder"], ["icon", "bars"], [1, "p-orderlist-empty-message"]],
        template: function UiOrderListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
            i0.ɵɵconditionalCreate(2, UiOrderListComponent_Conditional_2_Template, 3, 3, "div", 4);
            i0.ɵɵconditionalCreate(3, UiOrderListComponent_Conditional_3_Template, 3, 2, "div", 5);
            i0.ɵɵelementStart(4, "ul", 6, 0);
            i0.ɵɵlistener("cdkDropListDropped", function UiOrderListComponent_Template_ul_cdkDropListDropped_4_listener($event) {
              return ctx.onDrop($event);
            })("focus", function UiOrderListComponent_Template_ul_focus_4_listener($event) {
              return ctx.onListFocus($event);
            })("blur", function UiOrderListComponent_Template_ul_blur_4_listener($event) {
              return ctx.onListBlur($event);
            })("keydown", function UiOrderListComponent_Template_ul_keydown_4_listener($event) {
              return ctx.onItemKeydown($event);
            });
            i0.ɵɵrepeaterCreate(6, UiOrderListComponent_For_7_Template, 1, 1, null, null, ctx.trackBy, true);
            i0.ɵɵconditionalCreate(8, UiOrderListComponent_Conditional_8_Template, 2, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(9, UiOrderListComponent_Conditional_9_Template, 2, 0, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(10, UiOrderListComponent_Conditional_10_Template, 3, 0, "div", 8);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(18, _c3, ctx.stripedRows, ctx.controlsPosition === "left", ctx.controlsPosition === "right", ctx.dragdrop))("ngStyle", ctx.style);
            i0.ɵɵattribute("data-pc-section", "root");
            i0.ɵɵadvance();
            i0.ɵɵattribute("data-pc-section", "container");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.header || ctx.headerTemplate ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.filterBy ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.id + "_list")("ngStyle", ctx.listStyle)("tabindex", ctx.tabindex);
            i0.ɵɵattribute("data-pc-section", "list")("aria-activedescendant", ctx.focused ? ctx.focusedOptionId() : undefined)("aria-label", ctx.ariaLabel)("aria-labelledby", ctx.ariaLabelledBy);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.value);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.isEmpty() && (ctx.emptyMessageTemplate || ctx.emptyFilterMessageTemplate) ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.footerFacet ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loading ? 10 : -1);
          }
        },
        dependencies: [CommonModule, i2.NgClass, i2.NgTemplateOutlet, i2.NgStyle, UiIconsModule, i3.UiIconComponent, DragDropModule, i4.CdkDropList, i4.CdkDrag, i4.CdkDragHandle, i4.CdkDragPlaceholder, UiSpinnerComponent, UiContentCenteredComponent, SearchIcon],
        styles: ["@layer primeng{.p-orderlist[_ngcontent-%COMP%]{display:flex}.p-orderlist-controls[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center}.p-orderlist-list-container[_ngcontent-%COMP%]{flex:1 1 auto}.p-orderlist-list[_ngcontent-%COMP%]{list-style-type:none;margin:0;padding:0;overflow:auto;min-height:12rem}.p-orderlist-item[_ngcontent-%COMP%]{display:block;cursor:pointer;overflow:hidden;position:relative}.p-orderlist-item[_ngcontent-%COMP%]:not(.cdk-drag-disabled){cursor:move}.p-orderlist-item.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:0}.p-orderlist-item.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.p-orderlist.p-state-disabled[_ngcontent-%COMP%]   .p-orderlist-item[_ngcontent-%COMP%], .p-orderlist.p-state-disabled[_ngcontent-%COMP%]   .p-button[_ngcontent-%COMP%]{cursor:default}.p-orderlist.p-state-disabled[_ngcontent-%COMP%]   .p-orderlist-list[_ngcontent-%COMP%]{overflow:hidden}.p-orderlist-filter[_ngcontent-%COMP%]{position:relative}.p-orderlist-filter-icon[_ngcontent-%COMP%]{position:absolute;top:50%;margin-top:-.5rem;cursor:pointer}.p-orderlist-filter-input[_ngcontent-%COMP%]{width:100%}.p-orderlist-controls-right[_ngcontent-%COMP%]   .p-orderlist-controls[_ngcontent-%COMP%]{order:2}.p-orderlist-controls-right[_ngcontent-%COMP%]   .p-orderlist-list-container[_ngcontent-%COMP%]{order:1}.p-orderlist-list.cdk-drop-list-dragging[_ngcontent-%COMP%]   .p-orderlist-item[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}}[_nghost-%COMP%]{display:flex;flex:1;flex-direction:column}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist-controls[_ngcontent-%COMP%]{padding:.571em 1em}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist-controls[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:3em}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist-header[_ngcontent-%COMP%]{background-color:var(--panelHeaderBgColor);color:var(--panelHeaderTextColor);border:0;border-color:var(--panelHeaderBorderColor);padding:8px 10px;font-weight:400;text-align:center}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist-filter-container[_ngcontent-%COMP%]{padding:6px 15px;border:1px solid #c8c8c8;border-color:var(--panelContentBorderColor);color:var(--panelContentTextColor);background-color:var(--panelContentBgColor);margin:0;border-bottom:0 none;border-top:0 none}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist-filter-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100%;padding-right:2em}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist-filter-container[_ngcontent-%COMP%]   .p-orderlist-filter-icon[_ngcontent-%COMP%]{top:50%;margin-top:-6px;left:auto;right:21px;color:var(--inputListHeaderSearchIconColor)}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist-list[_ngcontent-%COMP%]{border:none;border-color:var(--inputListBorderColor);background-color:var(--inputListBgColor);color:var(--panelContentTextColor);padding:0}.p-orderlist[_ngcontent-%COMP%]{display:flex;flex:1;flex-direction:column}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist-list-container[_ngcontent-%COMP%]{display:flex;flex:1;flex-direction:column;width:100%;max-height:100%}.p-orderlist.has-buttons[_ngcontent-%COMP%]   .p-orderlist-list-container[_ngcontent-%COMP%]{width:83.333%}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist-list[_ngcontent-%COMP%]{flex:1;position:relative;list-style:none;margin:0;box-sizing:border-box;overflow-y:auto;min-height:initial!important}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist[_ngcontent-%COMP%]   .p-orderlist-list[_ngcontent-%COMP%]{background:transparent!important;border:1px solid var(contentSoftColor)!important;border-bottom:0!important;padding:0!important}.p-orderlist[_ngcontent-%COMP%]   .p-orderlist[_ngcontent-%COMP%]   .p-orderlist-item[_ngcontent-%COMP%]{margin-top:0!important;border-top:none!important;background:var(--contentColor)}.p-orderlist[_ngcontent-%COMP%]   .cdk-drop-list-dragging[_ngcontent-%COMP%]   .cdk-drag[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.p-orderlist[_ngcontent-%COMP%]   .cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .3s cubic-bezier(0,0,.2,1)}.p-orderlist-item[_ngcontent-%COMP%]{position:relative;border-bottom:1px solid var(--orderListItemBorderColor)!important;background:#f5f5f5;cursor:default;padding:6px 10px;margin:0;color:var(--inputListItemTextColor);background-color:var(--inputListItemBgColor)}.p-orderlist-item.selectable[_ngcontent-%COMP%]{cursor:pointer}.p-orderlist-item.p-highlight[_ngcontent-%COMP%]{background-color:var(--inputListItemHighlightBgColor);color:var(--inputListItemHighlightTextColor)}.p-orderlist-item.p-highlight[_ngcontent-%COMP%]     .list-item-name{color:var(--inputListItemHighlightTextColor)}.p-orderlist-item.p-highlight[_ngcontent-%COMP%]     .color-primary{color:var(--inputListItemHighlightTextColor)!important}.p-orderlist-item[_ngcontent-%COMP%]:not(.p-highlight).selectable:hover{background-color:var(--inputListItemHoverBgColor);color:var(--inputListItemHoverTextColor)}.p-dragdrop-enable[_ngcontent-%COMP%]   .p-orderlist-item[_ngcontent-%COMP%]   .drag-handle[_ngcontent-%COMP%]{width:20px;color:var(--inputListItemIconColor);cursor:move;display:block;background:var(--inputListDragHandleBgColor);position:absolute;right:0;top:0;bottom:-1px;display:flex;align-items:center;padding:0 5px;text-align:center}.p-dragdrop-enable[_ngcontent-%COMP%]   .p-orderlist-item[_ngcontent-%COMP%]   .drag-handle[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{pointer-events:none}.p-dragdrop-enable[_ngcontent-%COMP%]   .p-orderlist-item[_ngcontent-%COMP%]:not(.drag-handle-left){padding-right:30px}.p-dragdrop-enable[_ngcontent-%COMP%]   .p-orderlist-item.drag-handle-left[_ngcontent-%COMP%]{padding-left:30px}.p-dragdrop-enable[_ngcontent-%COMP%]   .p-orderlist-item.drag-handle-left[_ngcontent-%COMP%]   .drag-handle[_ngcontent-%COMP%]{right:initial;left:0}.p-dragdrop-enable[_ngcontent-%COMP%]   .p-orderlist-item.cdk-drag-placeholder[_ngcontent-%COMP%]{background:#0003}.p-dragdrop-enable[_ngcontent-%COMP%]   .p-orderlist-item.cdk-drag-preview[_ngcontent-%COMP%]{box-shadow:3px 3px 6px #0000004d}.cdk-drag-placeholder[_ngcontent-%COMP%]{min-height:50px;background:var(--dragPlaceholderBgColor);transition:transform .25s cubic-bezier(0,0,.2,1)}.loading-overlay[_ngcontent-%COMP%]{position:absolute;inset:0;background:var(--invertedOverlaySoftColor)}.bubbles[_nghost-%COMP%]   .p-orderlist-item[_ngcontent-%COMP%]{margin-bottom:5px;height:60px;width:60px;border-radius:50%;padding:5px!important;text-align:center;font-size:1.4rem;font-weight:700}.bubbles[_nghost-%COMP%]   .p-orderlist-item[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.bubbles[_nghost-%COMP%]   .p-orderlist-item[_ngcontent-%COMP%]   .drag-handle[_ngcontent-%COMP%]{width:100%;opacity:0}.bubbles.horizontal[_nghost-%COMP%]   .p-orderlist-list[_ngcontent-%COMP%]{display:flex}.bubbles.horizontal[_nghost-%COMP%]   .p-orderlist-item[_ngcontent-%COMP%]{margin:0 5px 5px 0}.fit-height[_nghost-%COMP%]{height:100%;max-height:100%}.fit-height[_nghost-%COMP%]   .p-orderlist[_ngcontent-%COMP%]{max-height:100%}.fit-height[_nghost-%COMP%]   .p-orderlist-list-container[_ngcontent-%COMP%]{overflow:hidden}"],
        changeDetection: 0
      });
    }
  }
  return UiOrderListComponent;
})();
export const UiOrderListBundle = [UiOrderListComponent, ...UiHeaderFooterBundle];